import { LineItem, LineItemObject } from "./LineItem";
import { Payment } from "./Payment";

export enum PaymentLineItemStatus {
    PENDING = "pending",
    PROCESSING = "processing",
    COMPLETE = "complete",
    FAILED = "failed",
}

export interface PaymentLineItem extends LineItem {
    object: LineItemObject.PAYMENT;
    status: PaymentLineItemStatus;
    amount: number;
    payment?: Payment;
}
